import { ParseError, parsePhoneNumberWithError } from "libphonenumber-js";
import { DateTime } from "luxon";

const getBody = (data) => {
  const { price, mark, model, year, mileage, vin, equipment } = data;
  const { subject, firstName, lastName, email, clientPhone } = data;

  const id = new Date().getTime();
  const date = DateTime.local();
  const formattedDate = date.toFormat("yyyy-MM-dd'T'HH:mm:ssZZ");

  let WITH_EMAIL = "";
  let WITH_PHONE = "";

  if (email) {
    WITH_EMAIL = `<email preferredcontact="1">${email}</email>`;
  }

  if (clientPhone) {
    try {
      const phoneNumber = parsePhoneNumberWithError(clientPhone);

      if (phoneNumber.isValid()) {
        WITH_PHONE = `<phone type="voice" time="nopreference" preferredcontact="0">${phoneNumber.number}</phone>`;
      }
    } catch (error) {
      if (error instanceof ParseError) {
        console.log(error.message);
      }
    }
  }

  let TEXT = [subject];

  if (!WITH_EMAIL && !WITH_PHONE) {
    throw Error("Please enter CORRECT email or phone");
  }

  return `
  <?xml version="1.0" encoding="UTF-8"?><?adf version="1.0"?>
  <adf>
      <prospect status="new">
          <id sequence="1" source="VM">VM-${id}</id>
          <requestdate>${formattedDate}</requestdate>
          <vehicle interest="buy" status="used">
              <id>${vin}</id>
              <year>${year}</year>
              <make>${mark}</make>
              <model>${model}</model>
              <vin>${vin}</vin>
              <stock>10114</stock>
              <trim></trim>
              <odometer units="mi">${mileage}</odometer>
              <price type="quote" currency="USD">${price}</price>
              <finance>
                  <method>Financing</method>
                  <amount />
              </finance>
              <extra>${equipment}</extra>
          </vehicle>
          <customer>
              <contact>
                  <name part="first" type="individual">${firstName}</name>
                  <name part="last" type="individual">${lastName}</name>
                  ${WITH_EMAIL}
                  ${WITH_PHONE}
                  <address>
                      <street line="1"></street>
                      <city>Los Angeles</city>
                      <regioncode>CA</regioncode>
                      <postalcode>90009</postalcode>
                      <country>US</country>
                  </address>
              </contact>
              <comments>${TEXT.join("\n")}</comments>
          </customer>
          <vendor>
              <id source="VM">sp379654</id>
              <vendorname>VM</vendorname>
              <contact>
                  <address>
                      <street line="1">3000 Foothill Blvd</street>
                      <city>La Crescenta</city>
                      <regioncode>CA</regioncode>
                      <postalcode>91214</postalcode>
                      <country>US</country>
                  </address>
              </contact>
          </vendor>
          <provider>
              <id sequence="1" source="VM">1</id>
              <name part="full" type="business">VM</name>
              <service>VM</service>
              <url>https://demo-market.3beep.ai/</url>
              <email preferredcontact="1">leads@beeplead.com</email>
              <phone type="voice" time="nopreference" preferredcontact="0"></phone>
              <contact>
                  <name part="full" type="business">VM</name>
                  <email preferredcontact="1">leads@beeplead.com</email>
                  <phone type="voice" time="nopreference" preferredcontact="0"></phone>
                  <address>
                      <street line="1">2 Canal Park 4th Flr</street>
                      <city>Cambridge</city>
                      <regioncode>MA</regioncode>
                      <postalcode>02141</postalcode>
                      <country>US</country>
                  </address>
              </contact>
          </provider>
      </prospect>
  </adf>
  `;
};

const send = async (data, email = "lamotors@devhub.3beep.ai") => {
  const raw = JSON.stringify({
    subject: `${data.mark} ${data.model} ${data.year}`,
    recipient: email,
    text: getBody(data),
    sender: data.email,
  });

  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: raw,
  };

  return await fetch(
    "https://h3mlxhceiuhanm4kq6zuqtjrhe0nizxa.lambda-url.eu-north-1.on.aws/",
    requestOptions
  );
};

export default send;
